<lcp-header></lcp-header>



<div class="main-content-container padding-bottom-0">
  <ng-container *ngIf="fields">
    <!-- <div class="main-content"> -->
    <section class="lcp-section">
      <div class="lcp-section-content">
        <div class="display-flex">
          <h1 *ngIf="fields['title']" class="section-title margin-top-20 margin-bottom-80 flex-55-not-sm">
            {{ fields['title'] }}
          </h1>
        </div>
      </div>
    </section>

    <section *ngFor="let section of fields['sections']"
      [ngClass]="['lcp-section', 'lcp-' + section.fields['slug']]"
      [class.is-inverted]="section.fields['inverted']">

      <div class="lcp-section-content padding-top-0">
        <div *ngIf="section.fields['title']" class="display-flex">
          <!-- {{ section.fields['title'] }} -->
          <h1 class="section-title margin-top-80 margin-bottom-80 flex-50-not-sm font-size-h1-sm1">
            {{ section.fields['title'] }}
          </h1>
        </div>
      
        <div class="section-main-content">
          <div class="block-container margin-top-0" *ngFor="let block of section.fields['items']">

            <ng-container *ngIf="block.fields['slug'] == 'team-employees'">
              <ng-content *ngTemplateOutlet="employeesBlock; context:{ block: block }"></ng-content>
            </ng-container>
    
            <ng-container *ngIf="block.fields['slug'] == 'team-partners'">
              <ng-content *ngTemplateOutlet="partnersBlock; context:{ block: block }"></ng-content>
            </ng-container>
          </div>
        </div>    
      </div>
    </section>  
  </ng-container>
</div>

<ng-template #employeesBlock let-block="block">

  <div *ngIf="block.fields['items']" 
    class="team-gallery">

    <div *ngFor="let employee of block.fields['items']"
      class="team-gallery-item">

      <ng-container *ngIf="employee.fields"> 
        <div class="team-employee-img-container">
          <!-- [style.background-image]="'url('+ itemPhoto(employee, 0) + ')'"> -->
          <img *ngIf="itemPhoto(employee, 0)"
            class="team-employee-img" 
            [src]="itemPhoto(employee, 0)">

          <div class="team-employee-hover-img">
            <!-- [style.background-image]="'url('+ itemPhoto(employee, 1) + ')'"> -->
            <img *ngIf="itemPhoto(employee, 1)"
              class="team-employee-img" 
              [src]="itemPhoto(employee, 1)">

            <div *ngIf="!itemPhoto(employee, 1)" 
              class="team-employee-img-placeholder"> 
              <div class="team-employee-img-square">
                <img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" height="100%">
              </div>
            </div>
          </div>
        </div>

        <div class="team-employee-text">
          <div class="team-employee-text--default">
            <div class="team-employee-name">
              <strong>{{ employee.fields.name }}</strong>
            </div>
            <div class="team-employee-description">
              {{ employee.fields.position }}
            </div>
          </div>

          <!-- KEEP - 26/01/07 - reimplement soon -->
          <!-- <div class="team-employee-text--phrase">
            When a deadline is near
          </div> -->
        </div>

        <div class="team-employee-spacer"></div>
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #partnersBlock let-block="block">
  <!-- <div class="max-width-800"> -->
  <div class="display-flex">
    <div class="flex-55-not-sm">
      <h2 *ngIf="block.fields['title']"
        class="block-title font-size-h1-sm1">
          {{ block.fields['title'] }}
      </h2>

      <div *ngIf="block.fields['body']" 
        class="section-item-body"
        [innerHtml]="lcpHelper.htmlFromRichText(block.fields['body'])">
      </div>
    </div>
  </div>

  <div *ngIf="block.fields['items']" 
    #partners
    class="partners-gallery">

    <!-- <lcp-carousel [media]="block.fields['media'].slice(0, totalLogos)"
      [slideCount]="5"
      (onInit)="handleCarouselInit($event)">
    </lcp-carousel> -->

    <lcp-carousel 
      *ngIf="block.fields['items']"
      [items]="block.fields['items']"  
      [slideCount]="slideCount"
      (onInit)="handleCarouselInit($event)">
    </lcp-carousel>

  </div>

</ng-template>